import React, { useState } from 'react';
import styles from '../styles';

export default function Avatar({ profile = {}, size = 96 }) {
  const [error, setError] = useState(false);

  const initials = profile.initials || '';
  const avatar = profile.avatar || '';

  return (
    <div
      onContextMenu={(e) => e.preventDefault()}
      draggable={false}
      style={{
        ...styles.avatarImg,
        width: size,
        height: size,
        backgroundImage: error || !avatar ? 'none' : `url("${avatar}")`,
        backgroundColor: 'white',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: size * 0.35,
        userSelect: 'none',
      }}
    >
      {(error || !avatar) && initials}

      {/* Imagen invisible para detectar error — con alt="" */}
      {avatar && <img src={avatar} alt="" style={{ display: 'none' }} onError={() => setError(true)} />}
    </div>
  );
}
